import localStorage from 'localStorage';

const ACTIVITY = 'activity';

export default {
  setId(activityId) {
    localStorage.setItem(ACTIVITY, activityId);
  },
  remove() {
    localStorage.removeItem(ACTIVITY);
  },
  getId() {
    return localStorage.getItem(ACTIVITY);
  },
};
